import {
  characterActions,
  ClassUtils,
  rulesEngineSelectors,
} from "@dndbeyond/character-rules-engine/es";

import type { CharacterActionMapper } from "../middleware";

type ClassLevelSetRequestAction = ReturnType<
  typeof characterActions.classLevelSetRequest
>;

/**
 * Level up or down in a class, sent as a "level" change with the new and
 * previous level. The action only has the new level, so the class and its
 * previous level come from the state before the change.
 */
export const mapClassLevelSet: CharacterActionMapper<
  ClassLevelSetRequestAction
> = (action, prevState) => {
  const { classId, level } = action.payload;

  // classId is the class's active id (the subclass id once one is chosen)
  const charClass = rulesEngineSelectors
    .getClasses(prevState)
    .find((cls) => ClassUtils.getActiveId(cls) === classId);
  if (!charClass) return null;

  const previousLevel = ClassUtils.getLevel(charClass);
  if (level === previousLevel) return null;

  return {
    changeCategory: "CLASS",
    changeDescriptors: [
      {
        changeType: "level",
        itemId: ClassUtils.getId(charClass),
        newValue: String(level),
        oldValue: String(previousLevel),
      },
    ],
  };
};
